<template>
    <div>进入后展示的主要内容</div>
</template>

<script>
    export default {
        name: "DefaultMain"
    }
</script>

<style scoped>

</style>
